module.exports = "../../app/cells/components/related_contests/show.erb";